/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-04-27 10:20:38
 * @LastEditTime: 2025-04-27 10:20:51
 * @LastEditors: ywj@originqc.com
 */
import React from 'react';
import { getlinkString } from '@/utils';
import './index.scss';

interface ServiceIdsProps {
  serviceIds: string;
}

const ServiceIds: React.FC<ServiceIdsProps> = ({ serviceIds }) => {
  const linkStringArr = getlinkString(serviceIds);

  return (
    <span className="service-ids-container">
      {linkStringArr.map((item:string, index:number) => (
        <React.Fragment key={index}>
          <span className="service-id-item">{item}</span>
          {index < linkStringArr.length - 1 && <span className="separator"></span>}
        </React.Fragment>
      ))}
    </span>
  );
};

export default ServiceIds;